import { Link } from "react-router-dom";
import React, { Component, Fragment } from "react";

import images from "../../utils/images";

class Home extends Component {
  navStyles = {
    background: "white",
    boxShadow: "2px 2px 8px rgba(0,0,0,0.1)",
    height: "60px",
  };

  menuStyle = {
    background: "#0CD0A7",
    borderRadius: "6px",
    color: "white",
    padding: "10px 20px",
    textDecoration: "none",
  };

  style = {
    color: "#0CD0A7",
    fontWeight: "100",
  };

  span = {
    color: "#08202C",
    fontWeight: "bold",
  };

  render() {
    return (
      <Fragment>
        <nav className="d-flex align-items-center px-2 px-lg-5" style={this.navStyles}>
          <ul className="mr-auto">
            <li>
              <img alt="logo" className="pl-3" src={images("./common/logo.svg")} />
            </li>
          </ul>

          <ul className="ml-auto">
            <li className="m-0">
              <Link style={this.menuStyle} to="/auth/sign-in">
                Login
              </Link>
            </li>
          </ul>
        </nav>

        <main>
          <div className="d-flex align-items-center mt-5 h-100 tw:justify-center">
            <h1 style={this.style}>
              <b>Welcome to </b>
              <span style={this.span}>aptihealth</span>
            </h1>
          </div>
        </main>
      </Fragment>
    );
  }
}

export default Home;
